import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { api, formatApiError, useAuth } from '@/App';
import { Lightning } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8ddecf7f-a4c9-427e-b02f-3053db4df717/artifacts/217o5tly_Marema_Logo.jpg";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Authentication failed');
        navigate('/login');
        return;
      }

      try {
        // Exchange session_id for session token
        const { data } = await api.post('/auth/session', null, { params: { session_id: sessionId } });
        setAuthUser(data);
        toast.success('Welcome!');
        
        // Clear the hash and redirect
        window.history.replaceState(null, '', window.location.pathname);
        
        if (data.role === 'admin' || data.role === 'staff') {
          navigate('/admin', { replace: true, state: { user: data } });
        } else {
          navigate('/portal', { replace: true, state: { user: data } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error(formatApiError(error));
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate, setAuthUser]);

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center">
      <div className="text-center">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <img src={LOGO_URL} alt="Marema Consulting" className="h-[4.5rem] w-auto" />
        </div>
        <div className="w-12 h-12 border-4 border-[#0055FF] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#4B5563]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
